import { useEffect, useState } from "react";
import { Key as KeyLabel } from "../../domain/keyboard";

type IsPressed = boolean
type EventCode = string
type CallbackFn = () => void

type Settings = {
  watchKey: KeyLabel
  onStartPress: CallbackFn
  onFinishPress: CallbackFn
}

export const usePressObserver = ({
  watchKey,
  onStartPress,
  onFinishPress
}: Settings): IsPressed => {
  const [pressed, setPressed] = useState<IsPressed>(false)

  useEffect(() => {
    const handlePressStart = ({ code }: KeyboardEvent): void => {
      if (pressed || !equal(watchKey, code)) return

      setPressed(true)
      onStartPress()
    };

    const handlePressFinish = ({ code }: KeyboardEvent): void => {
      if (!pressed || !equal(watchKey, code)) return

      setPressed(false)
      onFinishPress()
    };

    document.addEventListener('keydown', handlePressStart)
    document.addEventListener('keyup', handlePressFinish)

    return () => {
      document.removeEventListener('keydown', handlePressStart)
      document.removeEventListener('keyup', handlePressFinish)
    }
  }, [watchKey, pressed, setPressed, onStartPress, onFinishPress])

  return pressed;
}

function fromEventCode(code: EventCode): KeyLabel {
  const prefixRegex = /Key|Digit/gi
  return code.replace(prefixRegex, '')
}

function equal(watchedKey: KeyLabel, code: EventCode): boolean {
  return fromEventCode(code).toUpperCase() === watchedKey.toUpperCase()
}